var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NiceBlock',{staticClass:"nice-button",class:{ 'button-disabled': _vm.disabled },attrs:{"blockStyles":_vm.blockStyles}},[_c('div',{staticClass:"min-width-auto",attrs:{"slot":"detail"},slot:"detail"},[_vm._t("detail")],2),_c('div',{staticClass:"min-width-auto",attrs:{"slot":"main"},slot:"main"},[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }